import React, { useState, useEffect } from "react";
import styled from 'styled-components';
import './App.css';
import News from './components/News';
import NewsMobile from "./components/mobile/NewsMobile.js";
import Sports from './components/Sports';
import SportsMobile from "./components/mobile/SportsMobile.js";
import Layout from './components/Layout.js'
import Interactive from "./components/Interactive";
import Arts from './components/Arts';
import ArtsMobile from "./components/mobile/ArtsMobile.js";
import About from "./components/About";
import EditorLetter from "./components/EditorLetter";
import Opinion from './components/Opinion';
import OpinionMobile from "./components/mobile/OpinionMobile.js"
import Quad from "./components/Quad";
import QuadMobile from "./components/mobile/QuadMobile.js";
import Multimedia from "./components/Multimedia";
import MultimediaMobile from "./components/mobile/MultimediaMobile.js";
import Prime from "./components/Prime";
import PrimeMobile from "./components/mobile/PrimeMobile.js";
import Desktop30 from "./components/30";
import Mobile30 from "./components/30Mobile";
import { useMediaQuery } from 'react-responsive'; // Import useMediaQuery
import {BrowserRouter as Router } from 'react-router-dom';
import TopSection from "./components/TopSection";
import { mediaQueries } from "./shared/config.js";

const Div1 = styled.div`
background-color: #868066;
width: 100%;
height: 18vh;

${mediaQueries.mobile} {
  height: 10vh;
}
`;

const Div2 = styled.div`
background-color: #453D24;
width: 100%;
height: 18vh;

${mediaQueries.mobile} {
  height: 10vh;
}
`;
// import OliveSeparator from "./components/OliveSeparator.js";

function App() {
  const [ data, setData ] = useState(null);
  // console.log(data);
  
  useEffect(() => {
		fetch("https://kerckhoff.dailybruin.com/api/packages/flatpages/grad-issue24-2/")
		.then(res => res.json())
		.then(res => setData(res.data['article.aml']))
  }, [])

  const isMobile = useMediaQuery({ query: '(max-width: 486px)' });
  return data && (
      <Router>
        <Layout>
          <TopSection top_articles={data.top_articles} />
          <div id="editor-letter"><EditorLetter editor_letter={data.editor_letter} /></div>
          <div id="interactive" style={{backgroundColor: "#867F66"}}><Interactive /></div>
          {isMobile ? <div id="news"><NewsMobile news={data.news} /></div> : <div id="news"><News news={data.news} /></div>}
          <Div1 />
          {isMobile ? <div id="sports"><SportsMobile sports={data.sports} /></div> : <div id="sports"><Sports sports={data.sports} /></div>}
          <Div1 />
          {isMobile ?  <div id="arts"><ArtsMobile arts={data.arts} /></div> : <div id="arts"><Arts arts={data.arts} /></div>}
          <Div1 />
          {!isMobile ? <div id="opinion"><Opinion opinion={data.opinion}/></div> : <div id="opinion"><OpinionMobile opinion={data.opinion}/></div>}
          <Div1 />
          {!isMobile ? <div id="quad"><Quad quad={data.quad} /></div> : <div id="quad"><QuadMobile quad={data.quad} /></div>}
          <Div1 />
          {!isMobile ? <div id="multimedia"><Multimedia multi={data.multimedia} /></div> : <div id="multimedia"><MultimediaMobile multi={data.multimedia} /></div>}
          <Div1 />
          {!isMobile ? <div id="prime"><Prime prime={data.prime} /></div> : <div id="prime"><PrimeMobile prime={data.prime} /></div>}
          
          {!isMobile ? <><Div2 /><div id="thirty"><Desktop30 thirty={data.thirty} /></div></> : <div id="thirty"><Mobile30 thirty={data.thirty} /></div>}
          <div id="about"><About about={data.about} /></div>
        </Layout>
      </Router>
  );
}

export default App;

// function App() {
//   const [data, setData] = useState(null);

//   useEffect(() => {
//     fetch("https://kerckhoff.dailybruin.com/api/packages/flatpages/grad-issue-24")
//       .then(res => res.json())
//       .then(res => setData(res.data['article.aml']));
//   }, []);

//   const isMobile = useMediaQuery({ query: '(max-width: 426px)' });

//   return (
//     data && (
//       <Router>
//         <div className="App">
//           <Header />
//           <LandingAnim />
//           <NavBar />
//           <Routes>
//             <Route path="/" element={
//               <>
//                 <TopSection  top_articles={data.top_articles} />
//                 <EditorLetter editor_letter={data.editor_letter} />
//                 <News news={data.news} />
//                 <Sports sports={data.sports} />
//                 <Arts arts={data.arts} />
//                 <Opinion opinion={data.opinion} />
//                 <Quad quad={data.quad} />
//                 <Multimedia multi={data.multimedia} />
//                 <Prime prime={data.prime} />
//                 {!isMobile ? <Desktop30 thirty={data.thirty} /> : <Mobile30 thirty={data.thirty} />}
//                 <About about={data.about} />
//               </>
//             } />
//             <Route path="/news" element={<News news={data.news} />} />
//             <Route path="/sports" element={<Sports sports={data.sports} />} />
//             <Route path="/arts" element={<Arts arts={data.arts} />} />
//             <Route path="/editor-letter" element={<EditorLetter editor_letter={data.editor_letter} />} />
//             <Route path="/opinion" element={<Opinion opinion={data.opinion} />} />
//             <Route path="/the-quad" element={<Quad quad={data.quad} />} />
//             <Route path="/multimedia" element={<Multimedia multi={data.multimedia} />} />
//             <Route path="/prime" element={<Prime prime={data.prime} />} />
//             <Route path="/-30-" element={!isMobile ? <Desktop30 thirty={data.thirty} /> : <Mobile30 thirty={data.thirty} />} />
//             <Route path="/about" element={<About about={data.about} />} />
//           </Routes>

//           <Footer />
//         </div>
//       </Router>
//     )
//   );
// }

// export default App;




    // <div className="App">
    //     <Header/>
    //     <LandingAnim/>
    //     <NavBar/>
    //     <EditorLetter editor_letter={data.editor_letter}></EditorLetter>
    //     <News news={data.news}></News>
    //     <br></br>
    //     <Sports sports={data.sports}/>
    //     <br></br>
    //     <Arts arts={data.arts}/>
    //     <br></br>
    //     <EditorLetter editor_letter={data.editor_letter}></EditorLetter>
    //     <Opinion opinion={data.opinion}></Opinion>
    //     <Quad quad={data.quad}></Quad>
    //     <Multimedia multi={data.multimedia}></Multimedia>
    //     <Prime prime={data.prime}></Prime>
    //     {!isMobile ? <Desktop30 thirty={data.thirty} /> : <Mobile30 thirty={data.thirty} />}
    //     <About about={data.about}></About>
    //     <Footer/>
    // </div>


    // OLD CODE:    
//     import React, { useState, useEffect } from "react";
// import styled from 'styled-components';
// import './App.css';
// import Layout from './components/Layout';
// import News from './components/News';
// import Sports from './components/Sports';
// import Arts from './components/Arts';
// import About from "./components/About";
// import EditorLetter from "./components/EditorLetter";
// import Opinion from './components/Opinion';
// import Quad from "./components/Quad";
// import Multimedia from "./components/Multimedia";
// import Prime from "./components/Prime";
// import Desktop30 from "./components/30";
// import Mobile30 from "./components/30Mobile";
// import { useMediaQuery } from 'react-responsive';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

// const Div1 = styled.div`
// background-color: #868066;
// width: 100%;
// height: 18vh;
// `;

// const Div2 = styled.div`
// background-color: #453D24;
// width: 100%;
// height: 18vh;
// `;

// function App() {
//   const [data, setData] = useState(null);

//   useEffect(() => {
//     fetch("https://kerckhoff.dailybruin.com/api/packages/flatpages/grad-issue-24")
//       .then(res => res.json())
//       .then(res => setData(res.data['article.aml']));
//   }, []);

//   const isMobile = useMediaQuery({ query: '(max-width: 426px)' });

//   return (
//     data && (
//       <Router>
//         <Routes>
//           <Route path="/" element={
//             <Layout>
//               <EditorLetter editor_letter={data.editor_letter} />
//               <News news={data.news} />
//               <Sports sports={data.sports} />
//               <Arts arts={data.arts} />
//               <Opinion opinion={data.opinion} />
//               <Quad quad={data.quad} />
//               <Multimedia multi={data.multimedia} />
//               <Prime prime={data.prime} />
//               {!isMobile ? <Desktop30 thirty={data.thirty} /> : <Mobile30 thirty={data.thirty} />}
//               <About about={data.about} />
//             </Layout>
//           } />
//           <Route path="/news" element={<Layout><News news={data.news} /></Layout>} />
//           <Route path="/sports" element={<Layout><Sports sports={data.sports} /></Layout>} />
//           <Route path="/arts" element={<Layout><Arts arts={data.arts} /></Layout>} />
//           <Route path="/editor-letter" element={<Layout><EditorLetter editor_letter={data.editor_letter} /></Layout>} />
//           <Route path="/opinion" element={<Layout><Opinion opinion={data.opinion} /></Layout>} />
//           <Route path="/the-quad" element={<Layout><Quad quad={data.quad} /></Layout>} />
//           <Route path="/multimedia" element={<Layout><Multimedia multi={data.multimedia} /></Layout>} />
//           <Route path="/prime" element={<Layout><Prime prime={data.prime} /></Layout>} />
//           <Route path="/-30-" element={<Layout>{!isMobile ? <Desktop30 thirty={data.thirty} /> : <Mobile30 thirty={data.thirty} />}</Layout>} />
//           <Route path="/about" element={<Layout><About about={data.about} /></Layout>} />
//         </Routes>
//       </Router>
//     )
//   );
// }

// export default App;

// CODE
// import React, { useState, useEffect } from "react";
// import styled from 'styled-components';
// import './App.css';
// import Layout from './components/Layout';
// import News from './components/News';
// import Sports from './components/Sports';
// import Arts from './components/Arts';
// import About from "./components/About";
// import EditorLetter from "./components/EditorLetter";
// import Opinion from './components/Opinion';
// import Quad from "./components/Quad";
// import Multimedia from "./components/Multimedia";
// import Prime from "./components/Prime";
// import Desktop30 from "./components/30";
// import Mobile30 from "./components/30Mobile";
// import { useMediaQuery } from 'react-responsive';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import Interactive from './components/Interactive';

// const Div1 = styled.div`
// background-color: #868066;
// width: 100%;
// height: 18vh;
// `;

// const Div2 = styled.div`
// background-color: #453D24;
// width: 100%;
// height: 18vh;
// `;

// function App() {
//   const [data, setData] = useState(null);

//   useEffect(() => {
//     fetch("https://kerckhoff.dailybruin.com/api/packages/flatpages/grad-issue-24")
//       .then(res => res.json())
//       .then(res => setData(res.data['article.aml']));
//   }, []);

//   const isMobile = useMediaQuery({ query: '(max-width: 426px)' });

//   return (
//     data && (
//       <Router>
//         <Layout>
//           <div id="editor-letter"><EditorLetter editor_letter={data.editor_letter} /></div>
//           <div id="interactive" style={{backgroundColor: "#867F66"}}><Interactive /></div>
//           <div id="news"><News news={data.news} /></div>
//           <br />
//           <div id="sports"><Sports sports={data.sports} /></div>
//           <br />
//           <div id="arts"><Arts arts={data.arts} /></div>
//           <br />
//           <div id="opinion"><Opinion opinion={data.opinion} /></div>
//           <div id="quad"><Quad quad={data.quad} /></div>
//           <div id="multimedia"><Multimedia multi={data.multimedia} /></div>
//           <div id="prime"><Prime prime={data.prime} /></div>
//           {!isMobile ? <div id="thirty"><Desktop30 thirty={data.thirty} /></div> : <div id="thirty"><Mobile30 thirty={data.thirty} /></div>}
//           <div id="about"><About about={data.about} /></div>
//         </Layout>
//       </Router>
//     )
//   );
// }

// export default App;
